import { useCopying } from "../../../components/hooks/use-copying";
import { StyledTextWidget } from "./common";
import { Flex } from "../../../components/layout";
import ComplianceCourseImg from "../../../assets/ComplianceCoursePhoto2.png";
import { Link, Typography } from "@material-ui/core";


export const AMLMasteryCourse = () => {
    const [isCopying, setCopying] = useCopying(
        "https://elearning.sekuritance.com/"
    );
    return (
        <StyledTextWidget title="AML Mastery Course Coupon:" center>
            <Flex center>
                <img src={ComplianceCourseImg} />
            </Flex>

            {/* <Link href="https://elearning.sekuritance.com/p/the-compliance-academy">https://elearning.sekuritance.com/p/the-compliance-academy</Link> */}
            <br />
            <Typography variant="body2">
                Coupon Code
            </Typography>
            <Typography variant="body2">
                PORTHNKS
            </Typography>

        </StyledTextWidget>
    );
};
